import React from "react";
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import AppIcons from "../../assets/images/icons";
import SVGIcons from '../../assets/images/icons/svgIcons';
import { translateThis } from '../../helpers/language.helper';

import './team.scss';

const TeamSlider = () => {

  const teamSlideItem = [
    {
      memberImg: AppIcons.team1,
      name: 'H.E Vishnou Toolcanon',
      occupation: 'Chaiman/Secretary General - WDP',
      twitter: '/',
      linkedIn: '/',
      gitLab: '/'
    },
    // {
    //   memberImg: AppIcons.team2,
    //   name: 'Sarah Sajwani',
    //   occupation: 'Director General - WDP',
    //   twitter: '/',
    //   linkedIn: '/',
    //   gitLab: '/'
    // },
    {
      memberImg: AppIcons.team3,
      name: 'Divyanshu Mahant',
      occupation: 'Senior Manager -WDP',
      twitter: '/',
      linkedIn: '/',
      gitLab: '/'
    },

  ];

  return (
    <div className='team-slider f-wrp'>
      <Swiper
        spaceBetween={20}
        slidesPerView={1}
        
        modules={[Navigation, Pagination]}
        navigation
        loop
        autoplay={{
          delay: 7000,
          disableOnInteraction: false,
        }}
        pagination={{
          dynamicBullets: true,
          dynamicMainBullets: 3,
        }}
        className='team-item-wrp'
        breakpoints={{
          10: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          575: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          767: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        }}>

        {teamSlideItem.map((element, key) => (
          <SwiperSlide key={key} className="each-team-items f-wrp">
            <div className="each-team-box f-wrp">
              <span>
                <img src={element.memberImg} alt='partners' />
              </span>
              <h3>{element.name}</h3>
              <p>{element.occupation}</p>
              <ul className="social-list">
              {element.twitter ? <li><Link to={element.twitter}><SVGIcons.TwitterIcon /></Link></li> : null}
              {element.linkedIn ? <li><Link to={element.linkedIn}><SVGIcons.LinkedInIcon /></Link></li> : null}
              {element.gitLab ? <li><Link to={element.gitLab}><SVGIcons.GitHubIcon /></Link></li> : null}
              </ul>
            </div>

          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default TeamSlider;